module.exports = __webpack_public_path__ + "ee290219df8c42eec5e28c44ce552311.pdf";